import { Component, Input } from '@angular/core';
import { WidgetsEntity } from 'src/app/models/widget-entity.model';

@Component({
  selector: 'generic-widget',
  templateUrl: './generic-widget.component.html',
  styleUrls: ['./generic-widget.component.scss']
})
export class GenericWidgetComponent {

  @Input() widget?: WidgetsEntity | null;
}
